export const COOKIE_CONSENT_KEY = 'petbea_cookie_consent_v1';
export const COOKIE_CONSENT_HISTORY_KEY = 'petbea_cookie_consent_history';
export const COOKIE_CONSENT_VERSION = '1.0';
export const COOKIE_CONSENT_CHANGED_EVENT = 'petbea:cookie-consent-changed';
export const COOKIE_PREFERENCES_OPEN_EVENT = 'petbea:cookie-preferences-open';

export type CookieConsentAction = 'accept_all' | 'reject_optional' | 'custom';

export interface CookieConsentRecord {
  version: string;
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  date: string;
}

export interface CookieConsentHistoryEntry extends CookieConsentRecord {
  action: CookieConsentAction;
}

export interface CookieConsentPrefs {
  analytics: boolean;
  marketing: boolean;
}

export function readConsent(): CookieConsentRecord | null {
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<CookieConsentRecord>;
    return {
      version: parsed.version ?? COOKIE_CONSENT_VERSION,
      necessary: true,
      analytics: Boolean(parsed.analytics),
      marketing: Boolean(parsed.marketing),
      date: parsed.date ?? new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function readConsentHistory(): CookieConsentHistoryEntry[] {
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_HISTORY_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as CookieConsentHistoryEntry[]) : [];
  } catch {
    return [];
  }
}

export function writeConsent(prefs: CookieConsentPrefs, action: CookieConsentAction): CookieConsentRecord {
  const record: CookieConsentRecord = {
    version: COOKIE_CONSENT_VERSION,
    necessary: true,
    analytics: Boolean(prefs.analytics),
    marketing: Boolean(prefs.marketing),
    date: new Date().toISOString(),
  };

  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(record));
    const history = readConsentHistory();
    history.push({ ...record, action });
    window.localStorage.setItem(
      COOKIE_CONSENT_HISTORY_KEY,
      JSON.stringify(history.slice(-50)),
    );
  } catch {
    // silencia falhas de armazenamento (modo privado, cota, etc.)
  }

  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT, { detail: record }));
  return record;
}

export function requestCookiePreferences(): void {
  window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_OPEN_EVENT));
}